import { API2_HOST } from '@/utils/constants';
import { AUTHENTICATOR_ATTACHMENT } from '@/utils/constants/passkey';

import fetchData from './http';

// Base64 to ArrayBuffer
export function bufferDecode(value: string) {
  return Uint8Array.from(window.atob(value), (c) => c.charCodeAt(0));
}

// ArrayBuffer to URLBase64
export function bufferEncode(value: any) {
  return window
    .btoa(String.fromCharCode.apply(null, new Uint8Array(value) as any))
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=/g, '');
}

export interface GetPasskeyListResponse {
  ret_code: number;
  ret_msg: number;
  created_at: number;
  result: {
    items: GetPasskeyListResult[];
  };
}

export interface GetPasskeyListResult {
  item_id: string; //（设备唯一标识）
  display_name: string; // (Passkey 型号信息/ 浏览器+操作系统信息)
  nick_name: string;
  created_at: number; //（绑定时间）
  last_used_at: number; //（上次验证的时间）
  authenticator_attachment: AUTHENTICATOR_ATTACHMENT;
  transports: string;
}

export function getPasskeyList() {
  const url = `${API2_HOST}/user/public/passkeys/records`;
  return fetchData.post<GetPasskeyListResponse>(url);
}

export function registerPasskeyOptions({ verification_code }: any) {
  const url = `${API2_HOST}/user/public/registration/options`;
  return fetchData.post(url, {
    body: JSON.stringify({ verification_code }),
  });
}

export function registerPasskeyFinish(payload: any): Promise<any> {
  return new Promise((resolve, reject) => {
    const url = `${API2_HOST}/user/public/passkey/registration/verification`;
    fetchData
      .post(url, { body: payload })
      .then((response) => {
        console.log('registerPasskeyFinish response=', response);
        resolve(response);
      })
      .catch((error) => {
        console.log('registerPasskeyFinish error=', error);
        reject(error.response ? error.response.data : error);
      });
  });
}

export function authPasskeyUnbind(payload: {
  item_id: string;
  risk_token: string;
  item_type: string;
}) {
  const url = `${API2_HOST}/user/public/passkeys/pick`;
  return fetchData.post<{ ret_code: number; ret_msg: string; result: boolean }>(
    url,
    { body: JSON.stringify(payload) },
  );
}

export function passkeyRename(payload: {
  item_id: string;
  item_type: string;
  new_nick_name: string;
  risk_token: string;
}) {
  const url = `${API2_HOST}/user/public/passkeys/renickname`;
  return fetchData.post<{
    ret_code: number;
    ret_msg: string;
    result: { result: boolean };
  }>(url, { body: JSON.stringify(payload) });
}
